import { useTranslation } from "react-i18next";
import React from "react";
import { ConfirmDialog } from "@duosoftbg/nacid-components";
import useAppDispatch from "../../../../../hooks/redux/base/useAppDispatch";
import useAppSelector from "../../../../../hooks/redux/base/useAppSelector";
import { deleteNationalUniversity } from "../../../../../axios/api/services";
import { SEARCH_FILTERS_GROUP } from "../../../../../config/search/filters/groupsConfig";
import { useFormContext } from "react-hook-form";
import { onDeleteTableEntrySuccess } from "../../../../../utils/functions";
import { closeModal } from "../../../../../store/redux/slice/ComponentsControl/nationalUniversityControl";

const DeleteNationalUniversityDialog = ({ filterFn, records, total }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { getValues, setValue } = useFormContext();
  const group = SEARCH_FILTERS_GROUP.NATIONAL_UNIVERSITY;

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.nationalUniversityControl.modals.delete;
  });

  const handleCloseDialog = () => {
    dispatch(closeModal({ modalType: "delete" }));
  };

  const onSuccess = (response) => {
    onDeleteTableEntrySuccess(group, records.length, total, filterFn, dispatch, closeModal, getValues, setValue, t);
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleCloseDialog}
      promiseFunction={() => deleteNationalUniversity(id)}
      onSuccess={onSuccess}
      title={"t.nomenclature.delete.dialog"}
      message={"m.delete.nomenclature.warning.message"}
    />
  );
};

export default DeleteNationalUniversityDialog;
